import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import "antd/dist/antd.css";
import { DatePicker } from 'antd';
import Swal from 'sweetalert2';
import moment from 'moment';
import axios from 'axios';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import { MDBDataTable } from 'mdbreact';
// import { ExportReactCSV } from './ExportReactCSV';
import { Alert } from "@mui/material";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";


export default function BusinessHours({ company_id }) {

  const [columnData, setColumnData] = useState([])
  const [rowData, setRowData] = useState([])


  //This is for scrolling
  const titleRef = useRef()

  function handleBackClick() {
    titleRef.current.scrollIntoView({ behavior: 'smooth' })
  }


  useEffect(() => {

    axios.get(baseURL + "/get_audit/" + (company_id + "||business_hours"))
      .then((res) => {

        let column_data = []

        column_data.push(
          {
            label: 'Account ID',
            field: 'company_id',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Location Name',
            field: 'location_name',
            sort: 'asc',
            width: 270
          },
          {
            label: 'Type',
            field: 'type',
            sort: 'asc',
            width: 150
          },
          {
            label: 'From Date',
            field: 'from_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'To Date',
            field: 'to_date',
            sort: 'asc',
            width: 400
          },
          {
            label: 'Sunday',
            field: 'sunday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Monday',
            field: 'monday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Tuesday',
            field: 'tuesday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Wednesday',
            field: 'wednesday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Thursday',
            field: 'thursday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Friday',
            field: 'friday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Saturday',
            field: 'saturday',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created By',
            field: 'created_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated By',
            field: 'updated_by',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Created On',
            field: 'created_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Updated On',
            field: 'updated_date',
            sort: 'asc',
            width: 100
          },
          {
            label: 'IP Address',
            field: 'ip_address',
            sort: 'asc',
            width: 100
          },
          {
            label: 'Deleted?',
            field: 'deleted?',
            sort: 'asc',
            width: 100
          }

        )


        setColumnData(column_data);

        let rows_data = [];

        const myDataSet = res.data;
        for (var index = 0; index < res.data.length; index++) {


          let rowItem = {};
          const val = myDataSet[index];
          rowItem["company_id"] = val.company_id
          rowItem["location_name"] = val.location_name
          rowItem["type"] = val.special_day_name === undefined ? val.type : val.special_day_name
          rowItem["from_date"] = formatDate(new Date(val.from_date))
          rowItem["to_date"] = formatDate(new Date(val.to_date))
          rowItem["sunday"] = val.sunday.open1 + " - " + val.sunday.close1
          rowItem["monday"] = val.monday.open1 + " - " + val.monday.close1
          rowItem["tuesday"] = val.tuesday.open1 + " - " + val.tuesday.close1
          rowItem["wednesday"] = val.wednesday.open1 + " - " + val.wednesday.close1
          rowItem["thursday"] = val.thursday.open1 + " - " + val.thursday.close1
          rowItem["friday"] = val.friday.open1 + " - " + val.friday.close1
          rowItem["saturday"] = val.saturday.open1 + " - " + val.saturday.close1
          rowItem["created_by"] = val.created_by
          rowItem["updated_by"] = val.updated_by
          rowItem["created_date"] = formatDate_withTime(new Date(val.created_date))
          rowItem["updated_date"] = formatDate_withTime(new Date(val.updated_date))
          rowItem["ip_address"] = val.ip_address
          rowItem["deleted?"] = val['deleted?']

          rows_data.push(rowItem)
        }


        setRowData(rows_data)
      }).catch((e) => { });



  }, [])


  //Table Data
  const data = {
    columns: columnData,
    rows: rowData
  };




  return (
    <>

      <div className="row mt-3">
        <div className="col-md-12">
          <h5 className="mb-3">Business Hours Audit/Event Log: </h5>
          <MDBDataTable
            bordered
            large={true}
            data={data}
            sortable={true}
            responsiveLg={true}
            noBottomColumns={true}
            className='cust-table'
            btn
            
          />


        </div>
      </div>
    </>
  );
}
